import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatatableClickEvent } from '@basis/angular-components';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SelectItem } from 'primeng/primeng';
import { BaseStepComponent } from "app/base";
import { environment } from 'environments/environment';
import { PadraoService } from '../../../service/padrao.service';

@Component({
    selector: 'lotacao-etapa2',
    templateUrl: './lotacao-etapa2.component.html',
})
export class CrudLotacaoEtapa2Component extends BaseStepComponent {
    @Input() PaiOptions: SelectItem[];
    @Input() UFOptions: SelectItem[];
}


// WEBPACK FOOTER //
// ./src/app/lotacao/crud/etapas/lotacao-etapa2.component.ts